import { getVideoModelSelectionError } from "~/common/video/videoModels"
import {
  DEFAULT_VIDEO_CHANNEL_RESOLUTIONS,
  VIDEO_CHANNEL_RESOLUTIONS,
} from "~/common/constants"
import {
  getUploadedResourceKind,
  type UploadedResource,
} from "~/common/media/uploadedResources"

const dedupeResources = (resources: UploadedResource[]) => {
  const resourceMap = new Map<string, UploadedResource>()

  resources.forEach((resource) => {
    const key = resource.id || resource.url
    resourceMap.set(key, resource)
  })

  return Array.from(resourceMap.values())
}

export const mergeResources = (
  currentResources: UploadedResource[],
  nextResources: UploadedResource[],
) => {
  return dedupeResources([...currentResources, ...nextResources])
}

const getReferenceCounts = (references: UploadedResource[]) => {
  const imageCount = references.filter((resource) => {
    return getUploadedResourceKind(resource) === "image"
  }).length
  const videoCount = references.filter((resource) => {
    return getUploadedResourceKind(resource) === "video"
  }).length
  const audioCount = references.filter((resource) => {
    return getUploadedResourceKind(resource) === "audio"
  }).length

  return {
    imageCount,
    videoCount,
    audioCount,
  }
}

export const validateReferences = (
  prompt: string,
  references: UploadedResource[],
  model: API.Task.CreateVideoChannel,
  resolution: API.VideoResolution,
) => {
  if (!prompt.trim()) {
    return "请输入视频提示词"
  }

  const availableResolutions =
    VIDEO_CHANNEL_RESOLUTIONS[model] ?? DEFAULT_VIDEO_CHANNEL_RESOLUTIONS

  if (!availableResolutions.includes(resolution)) {
    return `当前模型不支持生成 ${resolution} 视频`
  }

  return getVideoModelSelectionError(model, { resources: references })
}

export const getReferenceSummary = (references: UploadedResource[]) => {
  const { audioCount, imageCount, videoCount } = getReferenceCounts(references)

  return [
    imageCount ? `${imageCount} 张图片` : "",
    videoCount ? `${videoCount} 个视频` : "",
    audioCount ? `${audioCount} 个音频` : "",
  ]
    .filter(Boolean)
    .join("，")
}

export const focusHomePromptInput = () => {
  document
    .querySelector<HTMLElement>("[data-home-prompt-input] .tiptap")
    ?.focus()
}
